document.addEventListener('DOMContentLoaded', () => {
  const wallTableBody = document.querySelector('.calculate-rolls .walls tbody');
  const defaultWallRow = document.querySelector('.calculate-rolls .walls tr:first-of-type').cloneNode(true);
  const nonCoveredTableBody = document.querySelector('.calculate-rolls .non-covered tbody');
  const defaultNonCoveredRow = document.querySelector('.calculate-rolls .non-covered tr:first-of-type').cloneNode(true);

  document.getElementById('calculate-rolls').addEventListener('click', (event) => {
    const wallArea = calculateArea('walls');
    const nonCoveredArea = calculateArea('non-covered');
    let rollArea = Number(event.target.dataset.width) * Number(event.target.dataset.length);
    if (Number(event.target.dataset.reducedCoverage)) {
      rollArea = rollArea * 0.85;
    }
    let rollsRequired = (wallArea - nonCoveredArea) / rollArea;
    if (document.querySelector('.calculate-rolls .wastage input').checked) {
      rollsRequired = rollsRequired * 1.1;
    }
    rollsRequired = Math.ceil(rollsRequired);

    const quantityInput = document.querySelector('.calculate-rolls .quantity__input');
    document.querySelector('.calculate-rolls .rolls-count').innerText = rollsRequired;
    quantityInput.value = rollsRequired;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    document.querySelector('.calculate-rolls .rolls-price').innerText = Shopify.formatMoney(
      rollsRequired * Number(event.target.dataset.price),
    );
    document.querySelector('.calculate-rolls .product-form__submit.button > span').innerText =
      `Add ${rollsRequired} Rolls to Basket`;
  });

  document.querySelector('.calculate-rolls .walls__add-row').addEventListener('click', () => {
    addRow(wallTableBody, defaultWallRow, 'walls');
  });

  document.querySelector('.calculate-rolls .non-covered__add-row').addEventListener('click', () => {
    addRow(nonCoveredTableBody, defaultNonCoveredRow, '');
  });

  refreshListeners();

  function calculateArea(tableClass) {
    let wallArea = 0;
    document.querySelectorAll(`.calculate-rolls .${tableClass} tr`).forEach((wall) => {
      wallArea =
        wallArea +
        Math.abs(wall.querySelector('input.width').value) * Math.abs(wall.querySelector('input.height').value);
    });
    return wallArea;
  }

  function addRow(tableBody, tableRow, wall) {
    tableBody.append(tableRow.cloneNode(true));
    reOrderWalls(tableBody, tableRow, wall);
  }

  function removeRow(tableBody, tableRow, wall) {
    tableBody.removeChild(tableRow);
    reOrderWalls(tableBody, tableRow, wall);
  }

  function reOrderWalls(tableBody, tableRow, wall) {
    tableBody.querySelectorAll('.wall-index').forEach((wallIndex, index) => {
      wallIndex.innerText = (wall === 'walls' ? 'Wall ' : 'Area ') + (index + 1);
    });
    refreshListeners();
  }

  function refreshListeners() {
    document.querySelectorAll('.calculate-rolls tr svg').forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        if (event.target.closest('tbody').children.length > 1) {
          removeRow(
            event.target.closest('tbody'),
            event.target.closest('tr'),
            event.target.closest('table').parentNode.classList.value,
          );
        }
        event.stopPropagation();
      });
    });
  }
});
